import React from "react";
import CommaSeprator from "../../common/CommaSeparator";
import { useFetchPrincipalWalletData } from "../../Hooks/WalletData/useGetWalletData";

/**
 * Purchase / Sale totals for Live Members (and approvals) listing.
 * Uses principal-ledger totals (same source as company Wallet overview) —
 * legacy get_wallet_by_id total_*_balance fields are empty under the new system.
 */
const GetBalanceComp = (props) => {
  const companyId = props?.id;
  const { data: principal, isLoading, isError } = useFetchPrincipalWalletData(
    companyId,
    { page: 1, limit: 1 }
  );

  const formatWalletValue = (value) => {
    if (value == null || Number.isNaN(Number(value))) return "N/A";
    return <CommaSeprator Price={Number(value).toFixed(2)} />;
  };

  if (!companyId) return "N/A";
  if (isLoading) return "…";
  if (isError) return "N/A";

  const totals = principal?.totals;
  if (props?.Sell) {
    return formatWalletValue(totals?.totalSales ?? 0);
  }
  if (props?.Purchase) {
    return formatWalletValue(totals?.totalPurchase ?? 0);
  }
  return "N/A";
};

export default GetBalanceComp;
